import { Button as HeadlessUiButton } from '@headlessui/react'
import type React from 'react'
import ButtonSpinner from './ButtonSpinner'

interface Props {
  className?: string
  disabled?: boolean
  onClick?: () => void
  submitting?: boolean
  title: string
  type?: 'button' | 'submit' | 'reset'
  dataTestId?: string
}

export default function Button({
  className = '',
  disabled = false,
  onClick,
  submitting = false,
  title,
  type = 'button',
  dataTestId,
}: Props): React.JSX.Element {
  return (
    <HeadlessUiButton
      className={`${className} custom-button-primary font-headline inline-flex justify-center gap-2`}
      disabled={disabled || submitting}
      onClick={onClick}
      type={type}
      data-testid={dataTestId}
    >
      {submitting && <ButtonSpinner />}

      {title}
    </HeadlessUiButton>
  )
}
